import useSWR from "swr";

const optionArgs = {};

export const useTypePersonal = (options = optionArgs) => {
  const { data, error } = useSWR(
    `${process.env.REACT_APP_BASE_URL_REQUESTS}/data-master/type-personal`,
    { ...options }
  );

  return {
    typePersonal: data,
    isLoading: !error && !data,
    isError: error,
  };
};
